import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Destroys',
		url: '/destroys',
		icon: 'times',
	}
];

export default class Destroys extends Framework.Components.View {
	render() {

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button onClick={this.toggle('modalDestroy')} size="sm" color="primary">
						<i className="fa fa-times"/>&nbsp;&nbsp;Add Destroy
					</Button>
				</Framework.Components.PageBar>

				<Collections.Destroys
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					scannedCode={!this.state['modalDestroy'] ? this.props.scannedCode : null}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name={"Destroy"}
					object={Objects.Destroy}
					history={this.props.history}
					toggle={this.state['modalDestroy']}
					reportClose={this.reportClose('modalDestroy')}
					afterSave={this.handleAfterSave}
					objectProps={{scannedCode: this.state['modalDestroy'] ? this.props.scannedCode : null}}
				/>

			</div>
		);
	}
}